<template>
  <image-empty-link :emptyLayout="emptyLayout" v-if="infoData.length === 0"></image-empty-link>
  <image-link :listLayout="listLayout" :infoData="infoData" v-else></image-link>
</template>

<script>
import informationUtil from "@/components/information/informationUtil";
import ImageLink from "@/components/information/ImageLink";
import ImageEmptyLink from "@/components/information/ImageEmptyLink";
import alertMixins from "@/mixins/alertMixins";

export default {
  name: "ImageComponent",
  mixins: [informationUtil, alertMixins],
  components: {ImageEmptyLink, ImageLink},
  inject: [],
  provide() {
    return {
      getDownloadFile: this.getDownloadFile
    }
  },
  props: {
    infoType: '',
  },
  data() {
    return {
      getFunc: '',
      detailApiParamSet: {},
      infoData: {},
      listLayout: '',
      emptyLayout: '',
      fileData: {}
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initConfig();
    this.getFile();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let informationConfig = this.returnInformationConfig(this.infoType);
      this.getFunc = informationConfig.getFunc;
      this.detailApiParamSet = informationConfig.detailApiParamSet;
      this.listLayout = informationConfig.listLayout;
      this.emptyLayout = informationConfig.emptyLayout;
    },
    getFile() {
      let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
      try {
        this.$api.$file[this.getFunc](params).then(res => res.Data.Result).then(res => {
          if (res.Info.type === 1) {
            this.infoData = res.List[0];
          } else {
            this.errorAlert('파일을 불러올 수 없습니다.');
          }
        })
      } catch (e) {
        this.errorAlert(e)
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>